<div class="db-ai-builder-create-page-blank__content">
  <div class="title">
    <i class="db-icon db-icon-ds-arrow-small" [ngStyle]="{'visibility': arrowHidden? 'hidden' : 'visible'}"
       (click)="onBack.emit()"></i>
    <h2>Blank page</h2>
  </div>
  <p class="mb20"><b>Title of the new page</b></p>

  <div class="ds-input-wrap mb9">
    <input type="text" class="ds-input" [formControl]="pageTitle"
           [ngClass]="{'error': pageTitle.invalid && pageTitle.touched}"
           placeholder="Title">
    <span *ngIf="pageTitle.invalid && pageTitle.touched"
          class="ds-input-error-msg" [innerHTML]="'This field is required.'"></span>
  </div>
  <div class="db-button-wrap">
    <button class="ds-btn-blue" [ngClass]="{'ds-btn-disabled': pageTitle.invalid || loading}" (click)="addPage()">
      <i class="db-icon db-icon-ds-diamond mr8" *ngIf="demoUser"></i>
      <span *ngIf="!loading">Add Page</span>
      <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
    </button>
    <div class="db-demo-tooltip" *ngIf="demoUser && (pageTitle.invalid || loading)">Unlock this feature with 10Web pro plans. <a (click)="showUpgradePopup.emit('Blank')"><span>Try now for free.</span></a></div>
  </div>


</div>
<div class="ai-builder-create-page__image" *ngIf="!isMobile">
</div>
